import React from 'react';

const QuoteStats = ({ quoteHistory, favorites, darkMode }) => {
  const getStatsData = () => {
    const categoryStats = {};
    const languageStats = {};
    
    quoteHistory.forEach(quote => {
      const category = quote.category || 'Náhodný';
      const language = quote.language || 'sk';
      
      categoryStats[category] = (categoryStats[category] || 0) + 1;
      languageStats[language] = (languageStats[language] || 0) + 1;
    });
    
    return { categoryStats, languageStats };
  };

  const { categoryStats, languageStats } = getStatsData();
  
  const mostUsedCategory = Object.entries(categoryStats)
    .sort(([,a], [,b]) => b - a)[0];
  
  const mostUsedLanguage = Object.entries(languageStats)
    .sort(([,a], [,b]) => b - a)[0];

  const getLanguageFlag = (lang) => {
    const flags = {
      'sk': '🇸🇰',
      'en': '🇺🇸', 
      'cz': '🇨🇿',
      'de': '🇩🇪'
    };
    return flags[lang] || '🌍';
  };

  return (
    <div className="stats-container">
      <h3>📊 Vaše štatistiky</h3>
      
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">🎯</div>
          <div className="stat-content">
            <div className="stat-number">{quoteHistory.length}</div>
            <div className="stat-label">Generované citáty</div>
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-icon">❤️</div>
          <div className="stat-content">
            <div className="stat-number">{favorites.length}</div>
            <div className="stat-label">Obľúbené citáty</div>
          </div>
        </div>
        
        {mostUsedCategory && (
          <div className="stat-card">
            <div className="stat-icon">🏆</div>
            <div className="stat-content">
              <div className="stat-number">{mostUsedCategory[0]}</div>
              <div className="stat-label">Najobľúbenejšia kategória</div>
            </div>
          </div>
        )}
        
        {mostUsedLanguage && (
          <div className="stat-card">
            <div className="stat-icon">{getLanguageFlag(mostUsedLanguage[0])}</div>
            <div className="stat-content">
              <div className="stat-number">{mostUsedLanguage[1]}x</div>
              <div className="stat-label">Najpoužívanejší jazyk</div>
            </div>
          </div>
        )}
      </div>
      
      {Object.keys(categoryStats).length > 0 && (
        <div className="category-breakdown">
          <h4>📈 Rozdelenie podľa kategórií</h4>
          <div className="category-bars">
            {Object.entries(categoryStats)
              .sort(([,a], [,b]) => b - a)
              .map(([category, count]) => (
                <div key={category} className="category-bar">
                  <div className="category-name">{category}</div>
                  <div className="category-progress">
                    <div 
                      className="category-fill" 
                      style={{ 
                        width: `${(count / Math.max(...Object.values(categoryStats))) * 100}%` 
                      }}
                    ></div>
                  </div>
                  <div className="category-count">{count}</div>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default QuoteStats;
